/**
 * POST /lessons/purchase — thin pass-through, returns the envelope unchanged
 * (docs/conventions/internalapi-envelope.md). The page classifies a refusal
 * off `httpStatus` / `error.code`, never the message text.
 *
 * No `:clubId` in the path. `getTenantHeaders` honours options only when BOTH
 * `tenantHandle` and `clubId` are set, so both are passed explicitly.
 */

import { apiClient } from '~/lib/apiClient';
import type { ApiResult } from '~/lib/apiClient/types';
import type { PurchaseLessonPayload, PurchaseLessonRequest } from '../types';

export function purchaseLesson(
  request: PurchaseLessonRequest,
  ctx: { clubId: number; tenantHandle: string | undefined },
): Promise<ApiResult<PurchaseLessonPayload>> {
  if (!ctx.clubId) throw new Error('clubId is required');
  return apiClient.post<PurchaseLessonPayload>('/lessons/purchase', request, {
    clubId: ctx.clubId,
    tenantHandle: ctx.tenantHandle,
    // Never auto-retry a charge: a 5xx after the provider charged would re-POST.
    retries: 0,
    // The page owns the failure copy.
    showErrorToast: false,
  });
}
